<template>
  <v-list-item
    class="list-item"
    data-testid="site-list-item"
    :key="site.id"
    @click="$emit('click', site)"
  >
    <v-list-item-avatar class="d-flex justify-center ma-0">
      <v-avatar size="24" color="blue lighten-5">
        <v-icon color="blue" size="14">
          mdi-warehouse
        </v-icon>
      </v-avatar>
    </v-list-item-avatar>

    <v-list-item-content class="pt-1 pb-1">
      <div class="d-flex align-center justify-space-between overflow-hidden">
        <div class="flex-grow-0 flex-shrink-1 overflow-hidden">
          <v-list-item-title class="font-size-13 name">
            <text-highlight
              highlightClass="yellow lighten-1"
              data-private
              highlightComponent="span"
              :queries="searchTerm || ''"
            >
              {{ siteTitle }}
            </text-highlight>
          </v-list-item-title>
          <p
            v-if="siteSubtitle"
            class="ma-0 font-size-10 blue-grey--text subtitle"
          >
            {{ siteSubtitle }}
          </p>
        </div>

        <v-icon
          v-if="selected"
          class="flex-grow-0 flex-shrink-0 ml-1"
          color="blue"
          size="20"
          >mdi-check-circle</v-icon
        >
      </div>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'SiteListItem',

  props: {
    site: { type: Object, required: true },
    searchTerm: { type: String, default: '' },
    selected: { type: Boolean, default: false },
  },

  computed: {
    siteTitle() {
      return this.site?.title || this.site?.name || ''
    },

    siteSubtitle() {
      return this.site?.subtitle || ''
    },
  },
}
</script>

<style scoped lang="scss">
.name {
  line-height: 20px !important;
}

.subtitle {
  line-height: 16px !important;
}

.list-item.v-list-item::before,
.list-item.v-list-item:hover {
  border-radius: 4px !important;
  background-color: $color-blue-grey-lighten3;
}
</style>
